var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "samr-oral-instruction-screen" }, [
    _c("div", { staticClass: "rounded p-3 mb-4 custom-bg" }, [
      _c("div", { staticClass: "card samr-card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "samr-legend-title mb-3" }, [
            _vm._v(" Leyenda ")
          ]),
          _c(
            "div",
            { staticClass: "row align-items-center justify-content-between" },
            _vm._l(_vm.levels, function(item) {
              return _c(
                "div",
                {
                  key: item.id,
                  staticClass: "col-auto d-flex align-items-center mb-2"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "rounded-pill py-1 px-3 text-semibold legend-button mr-3",
                      style: _vm.badge(item.color),
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.selectLegend(item)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(item.name) + " ")]
                  ),
                  _c("span", { staticClass: "legend-text" }, [
                    _vm._v(" " + _vm._s(item.description) + " ")
                  ])
                ]
              )
            }),
            0
          )
        ])
      ])
    ]),
    _c("div", { staticClass: "card samr-card" }, [
      _c("div", { staticClass: "card-header samr-card__header" }, [
        _vm._v(" Pantalla de Instrucciones Orales (PIO) ")
      ]),
      _c("div", { staticClass: "card-body samr-card__body" }, [
        _c("div", { staticClass: "form-row align-items-start mb-4" }, [
          _c(
            "div",
            { staticClass: "col-12 col-md-2 col-lg-1" },
            [
              _c("label", { staticClass: "samr-label" }, [_vm._v("Errores:")]),
              !_vm.isReadOnly
                ? _c("validation-provider", {
                    attrs: { name: "Errores", rules: "validErrorsValue" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.model.errors,
                                    expression: "model.errors"
                                  }
                                ],
                                staticClass: "form-control w-70",
                                class: {
                                  "samr-errors-input--invalid": errors[0]
                                },
                                attrs: { max: "5", min: "0", type: "number" },
                                domProps: { value: _vm.model.errors },
                                on: {
                                  input: [
                                    function($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.model,
                                        "errors",
                                        $event.target.value
                                      )
                                    },
                                    function($event) {
                                      return _vm.handleErrorsInput(
                                        $event.target.value
                                      )
                                    }
                                  ]
                                }
                              }),
                              errors[0]
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "samr-error-text mt-1 d-block"
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-times-circle"
                                      }),
                                      _vm._v(" " + _vm._s(errors[0]) + " ")
                                    ]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      326237525
                    )
                  })
                : _c("span", { staticClass: "d-block" }, [
                    _vm._v(" " + _vm._s(_vm.model.errors) + " ")
                  ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12 col-md-10 col-lg-11 mt-3 mt-md-0" },
            [
              _c("label", { staticClass: "samr-label" }, [
                _vm._v("Capacidad:")
              ]),
              _c("div", { staticClass: "samr-capacity mt-1" }, [
                _vm.currentLevel
                  ? _c(
                      "span",
                      {
                        staticClass: "rounded-pill py-1 px-3 text-semibold",
                        style: _vm.badge(_vm.currentLevel.color)
                      },
                      [_vm._v(" " + _vm._s(_vm.currentLevel.name) + " ")]
                    )
                  : _vm._e()
              ])
            ]
          )
        ]),
        _c(
          "div",
          { staticClass: "form-group mb-0" },
          [
            _c("label", { staticClass: "samr-label" }, [
              _vm._v("Interpretación:")
            ]),
            !_vm.isReadOnly
              ? _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-text-area", {
                              attrs: {
                                "count-classes": ["d-block", "small-counter"],
                                "custom-error-msg": "Es requerido",
                                disabled: _vm.isReadOnly,
                                error: errors[0],
                                maxlength: 5000,
                                "show-char-count": ""
                              },
                              model: {
                                value: _vm.model.interpretation,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "interpretation", $$v)
                                },
                                expression: "model.interpretation"
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    3025840182
                  )
                })
              : _c("span", { staticClass: "d-block mt-1" }, [
                  _vm._v(" " + _vm._s(_vm.model.interpretation) + " ")
                ])
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }